var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col p-1"},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"ml-2 list-disc"},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }